import { IconProps } from "../types/types"

const PlusIcon = (props: IconProps) => {

  const { className } = props

  return (
    <svg className={className} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* <path d="M5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9Z" strokeLinecap="round" strokeLinejoin="round"/> */}
      <path d="M5 3.3999V6.5999" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3.3999 5H6.5999" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default PlusIcon